import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { UserModel, userViewRoles } from '../../api/authentication/authentication.types';
import { AppState } from '../../store/store.types';
import {
  adminModuleEditRoles, brokerModuleEditRoles,
  manageBrokerModuleEditRoles,
  SupplierModel,
  userModuleEditRoles
} from '../../api/admin/admin.types';
import ConditionalRoute from '../../components/routes/ConditionalRoute';
import Classifiers from './views/classifiers/Classifiers';
import ClassifierDetails from './views/classifiers/ClassifierDetails';
import Notifications from './views/notifications/Notifications';
import NotificationDetails from './views/notifications/NotificationDetails';
import Users from './views/users/Users';
import UserDetails from './views/users/UserDetails';
import { supplierViewRoles } from '../../api/core/core.types';
import Supplier from './views/supplier/Supplier';
import Brokers from './views/brokers/Brokers';
import SupplierBrokers from './views/supplierbrokers/SupplierBrokers';
import SupplierBrokerDetails from './views/supplierbrokers/SupplierBrokerDetails';
import BrokerDetails from './views/brokers/BrokerDetails';

interface AdminEntityProps extends RouteComponentProps {
  user: UserModel;
  supplier: SupplierModel;
}

class AdminEntity extends React.PureComponent<PropsWithChildren<AdminEntityProps>> {
  render() {
    return (
      <>
        {this.props.children}
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/notifications`}
          render={(routeProps: any) => <Notifications {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/notifications/:id/view`}
          render={(routeProps: any) => <NotificationDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/notifications/create`}
          render={(routeProps: any) => <NotificationDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/classifiers`}
          render={(routeProps) => <Classifiers {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/classifiers/create`}
          render={(routeProps: any) => <ClassifierDetails {...routeProps} isNewCode/>}
        />
        <ConditionalRoute
          acceptedRoles={adminModuleEditRoles}
          exact
          path={`${this.props.match.path}/classifiers/:code/view`}
          render={(routeProps: any) => <ClassifierDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={userViewRoles}
          exact
          path={`${this.props.match.path}/users`}
          render={(routeProps) => <Users {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={userViewRoles}
          exact
          path={`${this.props.match.path}/users/:userLogin/view`}
          render={(routeProps: any) => <UserDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={userViewRoles}
          exact
          path={`${this.props.match.path}/users/create`}
          render={(routeProps: any) => <UserDetails {...routeProps} isNew/>}
        />
        <ConditionalRoute
          acceptedRoles={supplierViewRoles}
          exact
          path={`${this.props.match.path}/configuration`}
          render={(routeProps) => <Supplier {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={manageBrokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/manage-brokers`}
          render={(routeProps) => <Brokers {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={manageBrokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/manage-brokers/:id/view`}
          render={(routeProps) => <BrokerDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={manageBrokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/manage-brokers/create`}
          render={(routeProps) => <BrokerDetails {...routeProps} isNew />}
        />
        <ConditionalRoute
          acceptedRoles={brokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/brokers`}
          render={(routeProps) => <SupplierBrokers {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={brokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/brokers/:id/view`}
          render={(routeProps: any) => <SupplierBrokerDetails {...routeProps} />}
        />
        <ConditionalRoute
          acceptedRoles={brokerModuleEditRoles}
          exact
          path={`${this.props.match.path}/brokers/create`}
          render={(routeProps: any) => <SupplierBrokerDetails {...routeProps} isNew/>}
        />
      </>
    );
  }
}

const subnav = [
  {
    title: 'm1.config_Main menu item currently called \"Supplier\" ',
    route: '/admin/configuration',
    roles: supplierViewRoles
  },
  {
    title: 'm1.users',
    route: '/admin/users',
    roles: userModuleEditRoles
  },
  {
    title: 'Notifications',
    route: '/admin/notifications',
    roles: adminModuleEditRoles
  },
  {
    title: 'm2.classifiers',
    route: '/admin/classifiers',
    roles: adminModuleEditRoles
  },
  {
    title: 'm2.brokers',
    route: '/admin/brokers',
    roles: brokerModuleEditRoles
  },
  {
    title: 'm2.manage_brokers',
    route: '/admin/manage-brokers',
    roles: manageBrokerModuleEditRoles
  }
];

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user,
  supplier: state.authentication.activeSupplier
});

const adminEntity = connect(mapStateToProps, null)(AdminEntity);

export default {
  adminEntity,
  subnav
};
